import { useFormContext } from 'react-hook-form';

import { TotemCheckbox } from 'components/TotemCheckbox';

const REASSORT_DAYS = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const REASSORT_ROWS: { label: string; fieldName: 'freshReassortDays' | 'dryReassortDays' }[] = [
    { label: 'Réassort Fresh (Frigo)', fieldName: 'freshReassortDays' },
    { label: 'Réassort Dry (Sec)', fieldName: 'dryReassortDays' },
];

type FormValues = {
    freshReassortDays: boolean[];
    dryReassortDays: boolean[];
};

export const ReassortDaysSection = () => {
    const { setValue, watch } = useFormContext<FormValues>();

    function toggleDay(fieldName: 'freshReassortDays' | 'dryReassortDays', dayIndex: number) {
        const currentDays = watch(fieldName);
        setValue(
            fieldName,
            currentDays.map((value, index) => (index === dayIndex ? !value : value)),
        );
    }

    return (
        <table className="w-full text-foreground">
            <thead>
                <tr>
                    <th className="text-left">Nom</th>
                    {REASSORT_DAYS.map((day) => (
                        <th key={day}>{day}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {REASSORT_ROWS.map(({ label, fieldName }) => {
                    const days = watch(fieldName);

                    return (
                        <tr key={fieldName}>
                            <td>{label}</td>
                            {REASSORT_DAYS.map((_day, dayIndex) => (
                                <td key={dayIndex} className="text-center">
                                    <TotemCheckbox
                                        checked={days[dayIndex]}
                                        onChange={() => toggleDay(fieldName, dayIndex)}
                                    />
                                </td>
                            ))}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
